export const LEVELS = [
  {
    id: "native",
    name: "Native",
  },
  {
    id: "advanced",
    name: "Advanced",
  },
  {
    id: "intermediate",
    name: "Intermediate",
  },
  {
    id: "beginner",
    name: "Beginner",
  },
];
